export const SECONDARY_LEVELS = ["2", "3"];

export const HIDDEN_LEVEL_IDS = [1];

export const isSecondaryLevel = (level) => SECONDARY_LEVELS.includes(String(level));

export const isVisibleLevel = (levelId) => !HIDDEN_LEVEL_IDS.includes(Number(levelId));

export const LEVEL_LABELS = {
  2: "الصف الثالث الثانوي (إحصاء)",
  3: "الصف الثالث الثانوي (رياضة)",
};

export const LEVEL_IMAGES = {
  2: "/images/3sec-1.png",
  3: "/images/3sec-2.png",
};

export const getLevelLabel = (levelId, fallback = "") =>
  LEVEL_LABELS[Number(levelId)] || fallback || `المستوى ${levelId}`;
